import { render } from "./ThemeMarker.vue?vue&type=template&id=2f3175ae"
import script from "./ThemeMarker.vue?vue&type=script&lang=js"
export * from "./ThemeMarker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__